export default __webpack_public_path__ + "static/media/user_badge.3db901d4.svg";